var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('roles-form-with-data',{ref:"form",attrs:{"isEdit":_vm.isEdit,"id":_vm.id},on:{"submitLoad":_vm.submitLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }